import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import { FunctionalityViolationMark } from '../../../Functionality'
import { IInstance } from '../../model/types/Instance'
import { UsageStatusPopover } from '../UsageStatusPopover/UsageStatusPopover'

interface Props {
	instance: IInstance
	functionalityTemplateId: string | undefined
}

export const LicenseInstanceNameAndIndicators = (props: Props) => {
	const { instance, functionalityTemplateId } = props
	const usageStatus = instance.usageStatus
	const usageStatusReasons = instance.usageStatusReasons
	const usageStatusContext = instance.usageStatusContext
	const functionalityViolationWarning = 'Instance has value that violates functionality'
	const instanceName = instance.instanceName

	return (
		<Stack direction="row" gap={2} alignItems="center">
			{usageStatus && (
				<UsageStatusPopover
					usageStatus={usageStatus}
					usageStatusReasons={usageStatusReasons}
					usageStatusContext={usageStatusContext}
				/>
			)}
			{(!!functionalityTemplateId && (
				<Tooltip
					title={functionalityViolationWarning}
					placement="top"
				>
					<FunctionalityViolationMark />
				</Tooltip>
			))}
			<span>{instanceName}</span>
		</Stack>
	)
}